// Abgeschlossene Funnel-Leads (alles außer IN_PROGRESS). Forms ohne status
// stammen aus der Zeit vor dem schrittweisen Speichern (vor 20.05.2026) und
// wurden erst beim Abschluss angelegt.
import {
  FUNNEL_FORM_SOURCE,
  getSource,
  isInternal,
  normalizeEmail,
  parseData
} from './funnelDropouts'

const HUBSPOT_PORTAL_ID = '5244494'

const hubspotUrl = (objectType, id) =>
  `https://app.hubspot.com/contacts/${HUBSPOT_PORTAL_ID}/record/${objectType}/${id}`

const getHubspotLink = (data) => {
  if (data.hubspot_deal_id) return hubspotUrl('0-3', data.hubspot_deal_id)
  if (data.hubspot_contact_id) return hubspotUrl('0-1', data.hubspot_contact_id)
  return null
}

export const getFunnelLeads = (forms = []) =>
  forms
    .filter(
      (form) =>
        form.form_source === FUNNEL_FORM_SOURCE && form.status !== 'IN_PROGRESS'
    )
    .map((form) => {
      const data = parseData(form.data)
      return { form, data, email: normalizeEmail(data.EMAIL) }
    })
    .filter(({ email }) => email && !isInternal(email))
    .map(({ form, data, email }) => ({
      id: form.id,
      email,
      company: data.brand_name || null,
      employees: data.brand_employees || null,
      lead_ampel: data.lead_ampel || null,
      lead_score: data.lead_score ?? null,
      status: form.status || 'RECEIVED',
      lifecycle_stage: form.lifecycle_stage || null,
      partner_id: form.partner_id || null,
      hubspot_url: getHubspotLink(data),
      created_via_admin: Boolean(data.createdViaAdmin),
      source: getSource(data.funnel_context),
      createdAt: form.createdAt
    }))
    .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
